export function getRoomDisplayName(originalName, roomType, roomCategory) {
    return (originalName === null || originalName === void 0 ? void 0 : originalName.trim()) || [roomType, roomCategory].filter(Boolean).join(' ').trim();
}
